import { render, staticRenderFns } from "./AirClassOfService.vue?vue&type=template&id=306d6a08&"
import script from "./AirClassOfService.vue?vue&type=script&lang=js&"
export * from "./AirClassOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports